import React, { useState } from "react";
import DataTable from "../UI/table/DataTable";
import { shippinColumns } from "../../pages/shipping/shippingdata";
import { useQuery } from "react-query";
import { getDelivery } from "../../MyApi/delivery";
import DeliveryCharts from "./deliveryCharts";
import SkeletonWrapper from "../UI/skeletonWrapper";

const DeliveryReportsTab = ({statsWidget, isLoading}) => {
  const [current_page, setCurrentPage] = useState(1);
  const { data: deliveryData, isLoading: deliveryLoading } = useQuery(
    "getdeliveryData",
    getDelivery,
  );
  const deliveryCompaines = deliveryData?.data?.delivery_company || [];
  const totalItems = deliveryData?.data?.pagination?.total || 0;
  const lastPage = deliveryData?.data?.pagination?.last_page || 0;
  console.log('statsWidget', statsWidget)
  return (
    <div>

        <DataTable
          columns={shippinColumns}
          data={deliveryCompaines}
          title={"شركات التوصيل"}
          onAddClick={`${process.env.PUBLIC_URL}/shipping/store-shippings`}
          emptyMessage="لا توجد بيانات لشركات الشحن"
          itemsPerPage={lastPage}
          totalItems={totalItems}
          currentPage={current_page}
          setCurrentPage={setCurrentPage}
          isLoading={deliveryLoading}
          createPermission={"create_delivery_company"}
        />
     

      <SkeletonWrapper isLoading={isLoading}>
        <DeliveryCharts statsWidget={statsWidget}/>
      </SkeletonWrapper>
    </div>
  );
};

export default DeliveryReportsTab;
